import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import * as styles from './TextWidget.module.css';

/**
 * TextWidget Component
 * Displays rich text content configured by the user.
 * Supports basic formatting: bold, italic, underline, font size, and alignment.
 *
 * @param {Object} widget - Widget configuration containing text content and styling
 */
function TextWidget({ widget }) {
  const { t } = useTranslation();
  const { config } = widget;

  if (!config || !config.textContent) {
    return (
      <div className={styles.container}>
        <div className={styles.placeholder}>
          {t('dashboard.widgets.noTextContent')}
        </div>
      </div>
    );
  }

  const {
    textContent,
    fontSize = 14,
    textAlign = 'left',
    fontWeight = 'normal',
    fontStyle = 'normal',
    textDecoration = 'none',
  } = config;

  const textStyle = {
    fontSize: `${fontSize}px`,
    textAlign,
    fontWeight,
    fontStyle,
    textDecoration,
  };

  return (
    <div className={styles.container}>
      <div className={styles.content} style={textStyle}>
        {textContent}
      </div>
    </div>
  );
}

TextWidget.propTypes = {
  widget: PropTypes.shape({
    config: PropTypes.shape({
      textContent: PropTypes.string,
      fontSize: PropTypes.number,
      textAlign: PropTypes.oneOf(['left', 'center', 'right']),
      fontWeight: PropTypes.oneOf(['normal', 'bold']),
      fontStyle: PropTypes.oneOf(['normal', 'italic']),
      textDecoration: PropTypes.oneOf(['none', 'underline']),
    }),
  }).isRequired,
};

export default TextWidget;

